
import Boss from '@tencent/vft-common/Boss'
import isObject from 'lodash-es/isObject'
import toPairs from 'lodash-es/toPairs'
import ISpeedReport from './ISpeedReport'

const BOSS_CONFIG = {
  bossId: 4710,
  pwd: 8476392
}
export default class LJReport extends ISpeedReport {
  /**
   * 
   * @param {object} options
   * @param {string} options.project - 项目id(在棱镜平台申请的项目id)
   * @param {string} options.page - 页面id
   */
  constructor({ project, page } = {}) {
    super()
    this._boss = new Boss(BOSS_CONFIG)
    if (!project || !page) {
      throw new Error('[LJReport]project and page is required')
    }
    this._project = project
    this._page = page
  }

  setProject(project) {
    this._project = project
    return this
  }
  setPage(page) {
    this._page = page
  }
  setTags(tags) {
    this._tags = tags
    return this
  }
  /**
   * 
   * @param {object} params
   * @param {string} params.modId - 模块id
   * @param {object} params.metrics - 上报指标的key-value对象
   * @param {object} params.tags - 维度标签
   */
  report({ modId = '未知模块', metrics, tags = this._tags } = {}) {   
    const marks = {}
    this._eMarks.forEach((v, k) => {
      marks[k] = v
    }) 
    this.clear()
    return this._boss.report({
      busi: this._buildBizId(modId),
      metrics: this._buildMetrics({...marks, ...metrics}),
      tags: this._buildTags(tags)
    })
  }
  _buildMetrics(metrics) {
    if (!isObject(metrics)) {
      return ''
    }
    return toPairs(metrics).map(([k, v]) => `${k}=${v}`).join(' ')
  }
  _buildTags(tags) {
    if (!isObject(tags)) {
      return ''
    }
    return toPairs(tags).map(([k, v]) => `${k}=${v}`).join(' ')
  }
  _buildBizId(modId) {
    return `${this._project}.${this._page}.${modId}`
  }
}